import { render, staticRenderFns } from "./my_certificate.vue?vue&type=template&id=582ef9d8&scoped=true&"
import script from "./my_certificate.vue?vue&type=script&lang=js&"
export * from "./my_certificate.vue?vue&type=script&lang=js&"
import style0 from "./my_certificate.vue?vue&type=style&index=0&id=582ef9d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582ef9d8",
  null
  
)

export default component.exports